import { fr } from '../../assets/primelocale/fr.json';
import { en } from '../../assets/primelocale/en.json';
import { nl } from '../../assets/primelocale/nl.json';

export const primeTranslations: Record<string, any> = {
  en,
  fr,
  nl,
};

export const languageLabels: Record<string, string> = {
  en: 'English',
  fr: 'Français',
  nl: 'Nederlands',
};
